import { useQueryClient } from "@tanstack/react-query";
import { useAuthenticated } from "../../../authn";
import { OrgCategory } from "../../../generated/core-api";

/**
 * Helper hook that provides the common onSuccess callback for org mutations
 * @param category The org category to invalidate queries for
 * @returns A callback function to be used in mutation's onSuccess
 */
export function useOrgMutationSuccess(category: OrgCategory) {
  const queryClient = useQueryClient();
  const auth = useAuthenticated();

  return () => {
    queryClient.invalidateQueries({
      queryKey: ["orgs", category],
    });
    queryClient.invalidateQueries({
      queryKey: ["listOrgsByUser", auth.userId],
    });
    queryClient.invalidateQueries({
      queryKey: ["adminOrgs", auth.userId],
    });
  };
}
